<template>
    <div class="text-center space-y-3">
        <p class="h6 heading">
            Star Rating
        </p>

        <div class="flex justify-center [&>button:has(~button:hover)]:text-brand-3-2">
            <button
                v-for="i in 5"
                :key="i"
                class="[&_svg]:w-8 hover:text-brand-3-2 px-0.5"
                :class="{
                    'text-brand-3-2': i <= rating,
                    'text-brand-3-2/50': i > rating,
                }"
                v-html="i <= rating ? StarIcon : StarEmptyIcon"
                @click.prevent="emits('update:rating', i)"
            ></button>
        </div>

        <input
            ref="rating"
            type="hidden"
            min="1"
            max="5"
            :value="rating"
            @change="emits('update:rating', parseInt($event.target.value))"
        />
    </div>
</template>

<script setup>
    import StarIcon from '@img/icons/star.svg?raw';
    import StarEmptyIcon from '@img/icons/star-empty.svg?raw';

    const props = defineProps({
        rating: {
            type: Number,
            default: 0,
        }
    });

    const emits = defineEmits(['update:rating']);
</script>
